import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import {
  badgeClassForDisplayKind,
  resolveJobDisplayStatus,
} from '@/lib/sapJobStatus';

export default function SapJobStatusBadge({
  sapStatus,
  monitoringStage,
  className = '',
}) {
  const display = resolveJobDisplayStatus(sapStatus, monitoringStage);
  const badge = (
    <Badge variant="outline" className={`${badgeClassForDisplayKind(display.kind)} ${className}`}>
      {display.label}
    </Badge>
  );

  if (!display.tooltip) {
    return badge;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{badge}</TooltipTrigger>
        <TooltipContent className="max-w-xs">{display.tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
